var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaluogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_44",
    "data-name": "Raggruppa 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.715,
    height: 29.794,
    viewBox: "0 0 24.715 29.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_22",
    "data-name": "Rettangolo 22",
    width: 24.715,
    height: 29.794,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_43",
    "data-name": "Raggruppa 43",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_82",
    "data-name": "Tracciato 82",
    d: "M3.623,3.623a12.3,12.3,0,0,0,0,17.436l8.735,8.735,8.735-8.735A12.341,12.341,0,0,0,3.623,3.623M16.708,16.708a6.177,6.177,0,1,1,0-8.735,6.141,6.141,0,0,1,0,8.735",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaluogo);
export default __webpack_public_path__ + "static/media/iconaluogo.45b6aea4daf4513b28fc2d9405377a70.svg";
export { ForwardRef as ReactComponent };